import { render, staticRenderFns } from "./mockSideMenu.vue?vue&type=template&id=b142e4d4&scoped=true"
import script from "./mockSideMenu.vue?vue&type=script&lang=js"
export * from "./mockSideMenu.vue?vue&type=script&lang=js"
import style0 from "./mockSideMenu.vue?vue&type=style&index=0&id=b142e4d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b142e4d4",
  null
  
)

export default component.exports